import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';
import CustomToolbar from '../common/datagrid/CustomToolbar';

// searchStrtDt를 props에 추가합니다.
const PurchaseMaintenanceList = ({ 
  columns, 
  loading, 
  PurchaseMaintenanceList: rows, // 변수명 중복 방지를 위해 rows로 별칭 사용 가능
  error, 
  selectionModel, 
  setSelectionModel,
  searchStrtDt // 부모의 formik.values.searchStrtDt를 전달받음
}) => {
  const [pageSize, setPageSize] = React.useState(20);

  if (error) {
    return <div>에러 발생</div>;
  }

  return (
    <>
      {/* 행 색상을 변경하기 위한 스타일 정의 */}
      <style>
        {`
          .past-unissued-row {
            background-color: #ffd6d6 !important; /* 연한 주황색 (과거 미발행 강조) */
          }
          .past-unissued-row:hover {
            background-color: #ffd6d6 !important;
          }
        `}
      </style>

      <div style={{ display: 'flex', height: 'calc(100vh - 240px)' }}>
        <div style={{ flexGrow: 1 }}>
          <DataGridPro
            columns={columns}
            rows={rows ? rows : []}
            loading={loading}
            components={{
              Toolbar: CustomToolbar,
              LoadingOverlay: CustomLoadingOverlay,
            }}
            componentsProps={{
              toolbar: { fileName: '공통 코드 리스트' },
            }}
            initialState={{ pinnedColumns: { right: ['actions'] } }}
            pageSize={pageSize}
            onPageSizeChange={(newPage) => setPageSize(newPage)}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            pagination
            disableSelectionOnClick
            selectionModel={selectionModel}
            onSelectionModelChange={(newSelectionModel) => {
              setSelectionModel(newSelectionModel);
            }}
            getRowClassName={(params) => {
              const rowDate = params.row.salDt?.substring(0, 10); 
              const today = new Date().toISOString().substring(0, 10);

              if (today && rowDate < today) {
                return 'past-unissued-row';
              }
              return '';
            }}
          />
        </div>
      </div>
    </>
  );
};

export default PurchaseMaintenanceList;
